/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ViewExplore from './icon-view-explore.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ViewExplore {...validProps} />;
}
SvgComponent.iconName = 'viewExplore';

export const ViewExploreIcon = svgIconWrapper(SvgComponent);
